<template>
  <a
    class="sb-close-button"
    data-sb-regression="sb-close-button"
    href="#"
    @click.prevent="handleClose"
  >
    <span class="screen-reader-text">
      <sb-text value="common.close" />
    </span>
    <sb-text :value="escapeTrigger ? 'sbCloseButton.escapeAbbreviation' : ''" />
  </a>
</template>

<script>
import SbText from '@src/components/Text/SbText.vue';
import EscapeKeyMixin from '@src/utils/mixins/escapeKey';

/**
 * This is a fullscreen template with an X button. It is a wrapper used in action flows instead of using modals.
 */
export default {
  name: 'SbCloseButton',
  components: {
    SbText,
  },
  mixins: [EscapeKeyMixin],
  props: {
    /**
     * A boolean that allows the onclose event to be fired via hitting the escape key.
    */
    escapeTrigger: {
      type: Boolean,
      default: true,
    },
  },
  emits: [
    /**
    * Emitted when the close button is clicked
    */
    'onclose',
  ],
  data() {
    return {
      componentName: 'SbCloseButton',
      newComponent: 'this button only with the modals, for other use cases, talk to your designer',
    };
  },
  methods: {
    escapeKeyHandler(e) {
      if (this.escapeTrigger) this.handleClose(e);
    },
    handleClose(e) {
      this.$emit('onclose', e);
    },
  },
};
</script>

<style lang='scss'>
@import '@src/components/Modal/style/sb-close-button.scss';
</style>
